module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEJSURBVEhL7dSvSwNxGMfxm5hmFM0i9gWD2WK2LVlNgsluMAyT1WJYcXGg4L+wsH9g2EVsYwgK/nq/5R75euh2t6j3gRe7Pfc8z37dLatT53/kBq94zx+vMVcaOMl5HHFxUeUs4gKxwGNrJl0cKmUJVygusea5flILpbOMAWLwEr3kuedWcZ7UVCprGCGGTuF3v4CzvCZ77D1OajPTwh1sfsEBijnCG+yx15l92D812xjDwUfs4rfs4Rn2OuPstP6sjSc48IAtzMoOJnDGWXf8mEPEDXOLDZTNJu7hrDvc9RV/uA48Ka+MFVTNOnxjscednzekrzbMddHEvPGS9a8i9n37JHX+ZLLsA7AqWvL30E5oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-roofing/dark/24.png
// module id = 2380
// module chunks = 2